import styled from 'styled-components';
import { common, fonts, getColourStates } from 'themes/default';
import ButtonComponent from './ButtonComponent';

const buttonHeight = '32px';
const buttonBorderRadius = '3px';
const buttonFontSize = fonts.fontSizeRegular;
const buttonLineHeight = '20px'; // TODO
const buttonPadding = '0 8px 0 8px';
const buttonFontFamily = fonts.fontFamily;
const borderWidth = '1px';
const margin = '16px 0 16px 0';
const buttonFontWeight = 600;

const getStyle = ({ disabled: isDisabled, buttonType, variant }) => {
  if (isDisabled) {
    return getColourStates(common.buttons.disabled);
  }

  if (buttonType === 'link') {
    return getColourStates(common.buttons.tertiaryLink);
  }

  switch (variant) {
    case 'primary':
      return getColourStates(common.buttons.primary);
    case 'secondary':
      return getColourStates(common.buttons.secondary);
    case 'tertiary':
    default:
      return getColourStates(common.buttons.tertiary);
  }
};

export const StyledButton = styled(ButtonComponent)`
  text-align: center;
  border-style: solid;
  display: inline-block;
  position: relative;
  white-space: nowrap;

  font-family: ${buttonFontFamily};
  font-size: ${buttonFontSize};
  line-height: ${buttonLineHeight};
  border-radius: ${buttonBorderRadius};
  font-weight: ${buttonFontWeight};
  height: ${buttonHeight};

  background-color: ${(props) => getStyle(props).backgroundColour};
  border-color: ${(props) => getStyle(props).borderColour};
  border-width: ${(props) => (props.buttonType === 'link' ? '0' : borderWidth)};
  margin: ${(props) => props.margin || (props.buttonType === 'link' ? '0' : margin)};
  padding: ${(props) => props.padding || buttonPadding};
  pointer-events: ${(props) => (props.disabled && !props.$showTip ? 'none' : 'auto')};
  text-decoration: none;

  button,
  a,
  div {
    color: ${(props) => getStyle(props).fontColour};
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  }

  &:hover {
    background-color: ${(props) => getStyle(props).hoverBackgroundColour};
    border-color: ${(props) => getStyle(props).hoverBorderColour};

    button,
    a,
    div {
      color: ${(props) => getStyle(props).hoverFontColour};
    }
  }

  &:focus-visible {
    outline: none;
    background-color: ${(props) => getStyle(props).focusBackgroundColour};
    border-color: ${(props) => getStyle(props).focusBorderColour};

    button,
    a,
    div {
      color: ${(props) => getStyle(props).focusFontColour};
    }
  }

  &:active {
    outline: none;
    background-color: ${(props) => getStyle(props).activeBackgroundColour};
    border-color: ${(props) => getStyle(props).activeBorderColour};

    button,
    a,
    div {
      color: ${(props) => getStyle(props).activeFontColour};
    }
  }

  svg {
    margin-left: ${({ $hasLabel }) => ($hasLabel ? '0.5em' : '0')};
    pointer-events: none;
  }
`;

export const ButtonContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  outline: none;
  border: none;
  height: 100%;
  width: 100%;
  padding: 0;
  line-height: ${buttonHeight};
`;

export const SpinnerContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const StyledWithIconButton = styled.div`
  display: flex;
  align-items: center;
  width: 280px;
  padding: 0 10px;

  & svg {
    transition: all 0.4s ease 0s;
  }

  &:hover {
    svg {
      transform: translateX(10px);
    }
  }
`;
